import { connect } from 'react-redux'
import React from 'react'
import { t } from 'ttag'

import Field from '../../../form/Field'
import { suggestCollegesFromInput } from '../../../../actions/search'

const InstitutionSuggestField = ({
  searchFilterFormName,
  institutionSuggestions,
  filter,
  form,
  dispatch
}) => {
  return (
    <Field
      model={`${searchFilterFormName}.${filter.id}`}
      form={form}
      largeTextInput={true}
      theme="bootstrap3"
      label={t`Institution`}
      type="MultiSelect"
      options={institutionSuggestions}
      onSearchChange={term => dispatch(suggestCollegesFromInput(term))}
      createFromValue={values => {
        console.log(values)

        return values?.map(v => {
          return { label: v.name || 'unknown', value: v }
        })
      }}>
    </Field>
  )
}

export default connect(
  state => {
    const institutionSuggestions = state.search.collegeSuggestionsRequest.result?.map(
      major => {
        return {
          label: major.label,
          value: {
            name: major.label,
            institutionId: major.value
          }
        }
      }
    )

    //console.log(state.occupations)
    return {
      institutionSuggestions
    }
  },
  dispatch => ({
    dispatch
  })
)(InstitutionSuggestField)
